import React, { Component } from "react";
import styles from "./PreparePresentation.local.scss";
import { connect } from "react-redux";
import _ from "i18n";
import { getUserNameForAvatar } from "Utils";
import { TTP_API_URL } from "Config";
import { ICONS, SvgIcon } from "../Common/Icons";
import { Tooltip } from "antd";
import classNames from "classnames";

class Comments extends Component {
  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideFloatingActions.bind(this)
    );
  }
  setWrapperRef(node) {
    this.wrapperRef = node;
  }
  handleClickOutsideFloatingActions(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.props.displayCommentAction(null);
    }
  }

  render() {
    const { comment, user, selectedComment } = this.props;
    const fullName = comment.user.firstName + " " + comment.user.lastName;
    const avatar = [];
    if (comment.user.avatarUrl !== undefined) {
      avatar.push(
        <img className={styles.avatar} src={user.avatarUrl} alt={""} />
      );
    } else if (comment.user.avatar) {
      let url = `${TTP_API_URL}/${comment.user.avatar}`;
      avatar.push(<img className={styles.avatar} src={url} alt={""} />);
    } else {
      avatar.push(
        <span className={styles.avatar} style={{ marginLeft: "24%}" }}>
          {getUserNameForAvatar(comment.user.firstName, comment.user.lastName)}
        </span>
      );
    }
    return (
      <div
        className={`row ${styles.comment_container}`}
        key={`comment_${comment.id}`}
      >
        <span className={`large-2 medium-2 small-2`}>{avatar[0]}</span>
        <div
          className={classNames(
            `large-10 medium-10 small-10`,
            styles.comment_frame
          )}
        >
          <div className={styles.comment_frame_header}>
            <div className={styles.comment_owner}>
              {user.firstName === comment.user.firstName &&
              user.lastName === comment.user.lastName
                ? _("me")
                : fullName}
            </div>
            <div className={styles.actions}>
              <span
                className={`large-4 medium-4 small-4 ${styles.action}`}
                onClick={() => this.props.displayCommentAction(comment.id)}
              >
                <SvgIcon icon={ICONS.TREE_DOTS_ICON} />
              </span>
              {selectedComment === comment.id && (
                <div
                  className={styles.floating_frame}
                  ref={this.setWrapperRef.bind(this)}
                >
                  {comment.type === "TEXT" && (
                    <Tooltip placement="top" title={_("update")}>
                      <span
                        className={`large-4 medium-4 small-4 ${styles.action}`}
                        onClick={() =>
                          this.props.updateComment(comment.id, comment.content)
                        }
                      >
                        <SvgIcon
                          icon={ICONS.EDIT_ICON}
                          className={styles.update_icon}
                        />
                      </span>
                    </Tooltip>
                  )}
                  <Tooltip placement="top" title={_("delete")}>
                    <span
                      className={`large-4 medium-4 small-4 ${styles.action}`}
                      onClick={() => this.props.deleteComment(comment.id)}
                    >
                      <SvgIcon
                        icon={ICONS.DELETE_ICON}
                        className={styles.delete_icon}
                      />
                    </span>
                  </Tooltip>
                </div>
              )}
            </div>
          </div>
          <div className={styles.comment_frame_body}>
            {comment.type === "AUDIO" ? (
              <audio
                id={`audio-${comment.id}`}
                controls
                src={comment.content ? comment.content.path : null}
              />
            ) : this.props.commentUpdate === comment.id ? (
              <textarea
                onKeyPress={e => this.props.keyPressed(e, comment.id)}
                id={comment.id}
                onChange={e => this.props.handleInputChange(e)}
              >
                {comment.content}
              </textarea>
            ) : (
              <p>{comment.content}</p>
            )}
          </div>
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  commentUpdate: state.preparePresentation.commentUpdate,
  user: state.auth.user,
  lng: state.params.lng
});

export default connect(mapStateToProps)(Comments);



// WEBPACK FOOTER //
// ./src/components/PreparePresentation/Comments.js